export default __webpack_public_path__ + "static/media/hero-img-new.34854c3d.png";